import types from '../../mutation-types';
import AuditLogsAPI from '../../../api/auditLogs';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import { downloadXlsxFile } from 'dashboard/helper/downloadHelper';

const cleanUpQueryPayload = queryPayload => {
  if (!queryPayload.payload) return queryPayload;
  if (!Array.isArray(queryPayload.payload)) return queryPayload;

  const isPlainObject = value =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

  const hasValidValues = item => {
    const { values } = item;

    if (Array.isArray(values)) {
      return values.length > 0;
    }

    if (isPlainObject(values)) {
      return (
        values.from &&
        values.from.length > 0 &&
        values.to &&
        values.to.length > 0
      );
    }

    return false;
  };

  return {
    ...queryPayload,
    payload: queryPayload.payload.filter(hasValidValues),
  };
};

export const actions = {
  async fetch({ commit }, { page } = {}) {
    commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: true });
    try {
      const response = await AuditLogsAPI.get({ page });
      const { audit_logs: logs = [] } = response.data;
      const {
        total_entries: totalEntries,
        per_page: perPage,
        current_page: currentPage,
      } = response.data;
      commit(types.SET_AUDIT_LOGS, logs);
      commit(types.SET_AUDIT_LOGS_META, {
        totalEntries,
        perPage,
        currentPage,
      });
      commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return logs;
    } catch (error) {
      commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },

  search: async ({ commit }, { search, page }) => {
    commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: true });
    try {
      const response = await AuditLogsAPI.search(search, page);
      const { audit_logs: logs = [] } = response.data;
      const {
        total_entries: totalEntries,
        per_page: perPage,
        current_page: currentPage,
      } = response.data;

      commit(types.SET_AUDIT_LOGS, logs);
      commit(types.SET_AUDIT_LOGS_META, {
        totalEntries,
        perPage,
        currentPage,
      });
      commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });

      return logs;
    } catch (error) {
      commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },

  setAuditLogsFilters({ commit }, data) {
    commit(types.SET_AUDIT_LOGS_FILTERS, data);
  },

  clearAuditLogsFilters({ commit }) {
    commit(types.CLEAR_AUDIT_LOGS_FILTERS);
  },

  filter: async ({ commit }, { page = 1, queryPayload } = {}) => {
    commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: true });
    try {
      const {
        data: { audit_logs: logs = [], total_entries, per_page, current_page },
      } = await AuditLogsAPI.filter(page, cleanUpQueryPayload(queryPayload));

      commit(types.SET_AUDIT_LOGS, logs);
      commit(types.SET_AUDIT_LOGS_META, {
        totalEntries: total_entries,
        perPage: per_page,
        currentPage: current_page,
      });
      commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return logs;
    } catch (error) {
      commit(types.SET_AUDIT_LOGS_UI_FLAG, { fetchingList: false });
      return throwErrorMessage(error);
    }
  },

  downloadAuditLogs: async ({ commit }, { queryPayload = null } = {}) => {
    commit(types.SET_AUDIT_LOGS_UI_FLAG, { isDownloading: true });
    try {
      const response = await AuditLogsAPI.download(
        cleanUpQueryPayload(queryPayload)
      );

      const date = new Date();
      const dateStr = date.toISOString().split('T')[0];
      const filename = `audit-logs-${dateStr}.xlsx`;

      downloadXlsxFile(filename, response.data);

      commit(types.SET_AUDIT_LOGS_UI_FLAG, { isDownloading: false });
      return true;
    } catch (error) {
      commit(types.SET_AUDIT_LOGS_UI_FLAG, { isDownloading: false });
      return throwErrorMessage(error);
    }
  },
};
